import { createAction, props } from '@ngrx/store'
import { Update } from '@ngrx/entity'
import { HttpErrorResponse } from '@angular/common/http'
import { ProjectorContainer } from './projector-containers.models'

// Load Actions
export const loadProjectorContainers = createAction(
  '[ProjectorContainers Page] Load Projector Containers',
  props<{ urlName?: string }>(),
)

export const loadProjectorContainersSuccess = createAction(
  '[ProjectorContainers/API] Load Projector Containers Success',
  props<{ projectorContainers: ProjectorContainer[] }>(),
)

export const loadProjectorContainersFailure = createAction(
  '[ProjectorContainers/API] Load Projector Containers Failure',
  props<{ error: HttpErrorResponse }>(),
)

// Selection Actions
export const selectProjectorContainer = createAction(
  '[ProjectorContainer/Page] Select Projector Container',
  props<{ uuid: string }>(),
)

export const clearSelectedProjectorContainer = createAction(
  '[ProjectorContainer/Page] Clear Selected Projector Container',
)

export const goToPresenter = createAction('[ProjectorContainer/Page] Go to presenter', props<{ uuid: string }>())

export const launchPresenter = createAction('[ProjectorContainer/Page] Launch presenter', props<{ uuid?: string }>())

// Update Actions
export const updateSelectedProjectorContainer = createAction(
  '[ProjectorContainer/Page] Update Selected Projector Container',
  props<{ projectorContainer: Partial<ProjectorContainer> }>(),
)

export const updateSelectedProjectorContainerSuccess = createAction(
  '[ProjectorContainer/Page] Update Selected Projector Container Success',
  props<{ update: Update<ProjectorContainer> }>(),
)

export const updateSelectedProjectorContainerFailure = createAction(
  '[ProjectorContainer/Page] Update Selected Projector Container Failure',
  props<{ error: HttpErrorResponse }>(),
)

// Create Actions
export const openCreateProjectorDialog = createAction('[ProjectorContainer/Page] Open Create Projector Dialog')

export const createProjectorContainer = createAction(
  '[ProjectorContainer/Page] Create Projector Container',
  props<{ projectorContainer: Partial<ProjectorContainer> }>(),
)

export const createProjectorContainerSuccess = createAction(
  '[ProjectorContainer/Page] Create Projector Container Success',
  props<{ projectorContainer: ProjectorContainer }>(),
)

export const createProjectorContainerFailure = createAction(
  '[ProjectorContainer/Page] Create Projector Container Failure',
  props<{ error: HttpErrorResponse }>(),
)

// Delete Actions
export const deleteProjectorContainer = createAction(
  '[ProjectorContainer/Page] Delete Projector Container',
  props<{ uuid: string }>(),
)

export const deleteProjectorContainerSuccess = createAction(
  '[ProjectorContainer/Page] Delete Projector Container Success',
  props<{ uuid: string }>(),
)

export const deleteProjectorContainerFailure = createAction(
  '[ProjectorContainer/Page] Delete Projector Container Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const duplicateSlide = createAction(
  '[ProjectorContainer/Page] Duplicate Slide',
  props<{ projectorUuid: string; name?: string }>(),
)

export const duplicateSlideSuccess = createAction(
  '[ProjectorContainer/Page] Duplicate Slide Success',
  props<{ projectorUuid: string }>(),
)

export const duplicateSlideFailure = createAction(
  '[ProjectorContainer/Page] Duplicate Slide Failure',
  props<{ error: HttpErrorResponse }>(),
)

// Projector Container Data Initialization Actions
export const loadProjectorContainerData = createAction('[ProjectorContainer/Page] Load Projector Container Data')

export const projectorContainerDataLoadedAndReady = createAction(
  '[ProjectorContainer/Page] Projector Container Data Loaded And Ready',
)

export const projectorContainerDataLoadFailure = createAction(
  '[ProjectorContainer/Page] Projector Container Data Load Failure',
  props<{ error: HttpErrorResponse }>(),
)
